import React, { Suspense } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import NavbarOfDashborad from "../Custom Components/Navbar/navbarDashborad";

import { t } from "../../i18n";

// Shared shell for every signed-in page: the brand bar and tab navigation stay mounted while only
// the page below them changes. Pages render their own content and set no outer wrapper, top margin
// or navbar of their own.
const DashboardLayout = () => (
  <div className="bg-slate-50 min-h-screen p-4 sm:p-6">
    <NavbarOfDashborad />
    <div className="mt-6 lg:flex lg:items-start lg:gap-6">
      <Sidebar />
      <main className="min-w-0 flex-1">
        <Suspense
          fallback={
            <div role="status" className="py-20 text-center text-slate-500">
              {t("جاري التحميل...")}
            </div>
          }
        >
          <Outlet />
        </Suspense>
      </main>
    </div>
  </div>
);

export default DashboardLayout;
